export const formatUnderScoreText = (text) => {
  const formatWords = text.split('_');
  const capitalizedWords = formatWords.map(word => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalizedWords.join(' ');
}